﻿"use strict";

import GoogleMapsLoader from "google-maps";
import MarkerClusterer from "@google/markerclusterer";

const map = {

	init: function () {

		GoogleMapsLoader.KEY = "AIzaSyBMBvrlVKPV0URNrjAs7jSsrBSdyhWh7Go";
		GoogleMapsLoader.VERSION = "3.34";

    let maps = [...document.querySelectorAll("[data-map]")];


		maps.map(map => {

			if (!map) return;

      GoogleMapsLoader.LANGUAGE = map.dataset.mapLang;

			let markerStyle = this.getMarkerStyles(map);

			GoogleMapsLoader.load(google => {

				let googleMap = new google.maps.Map(map.querySelector("[data-map-container]"), {
					center: {
						lat: 55.426835,
						lng: 9.727015
					},
						zoom: 8,
					disableDefaultUI: true,
					scaleControl: true,
					zoomControl: true,
					gestureHandling: 'greedy',
					scrollwheel: false,
					styles: [{
							"featureType": "administrative",
							"elementType": "geometry",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "administrative.country",
							"elementType": "labels.icon",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "administrative.land_parcel",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "administrative.neighborhood",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "administrative.province",
							"elementType": "labels.icon",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "administrative.province",
							"elementType": "labels.text",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "poi",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "poi",
							"elementType": "geometry.fill",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "poi",
							"elementType": "labels.text",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "road",
							"elementType": "labels",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "road",
							"elementType": "labels.icon",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "transit",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "water",
							"elementType": "labels.text",
							"stylers": [{
								"visibility": "off"
							}]
						}
					]
				});

				this.setMarkers(map, googleMap, markerStyle);

			});

		});
	},

	getMarkerStyles: function (map) {
		let markerStyleEl = map.querySelector("[data-map-markerstyle]");
		if (!markerStyleEl) return {
			backgroundColor: "rgb(0,0,0)",
			color: "rgb(255,255,255)"
		};

		return getComputedStyle(markerStyleEl);
	},

	setMarkers: function (map, googleMap, markerStyles) {

		let locations = [...map.querySelectorAll("[data-map-location*=',']")];

		let markerImg = "data:image/svg+xml;base64," + window.btoa('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="28" xmlns:xlink="http://www.w3.org/1999/xlink" fill="' + markerStyles.backgroundColor + '"><path d="M10 .667A9.327 9.327 0 0 0 .667 10C.667 17 10 27.333 10 27.333S19.333 17 19.333 10A9.327 9.327 0 0 0 10 .667zm0 12.666a3.335 3.335 0 0 1 0-6.666 3.335 3.335 0 0 1 0 6.667z"/></svg>');

		let bounds = new google.maps.LatLngBounds();
		let markers = locations.map(function (location, i) {
			let locationArray = location.getAttribute("data-map-location").toString().split(',');
			if (locationArray.length < 2) {
				return;
			}

			let lat = parseFloat(locationArray[0]);
			let lng = parseFloat(locationArray[1]);

			if (isNaN(lat) || isNaN(lng)) {
				return;
			}

			bounds.extend(new google.maps.LatLng(lat, lng));

			let markerOptions = {
				position: {
					lat,
					lng
				},
				animation: google.maps.Animation.DROP,
				map: googleMap
			};

			let isIE = false;
			let ua = window.navigator.userAgent;
			if (ua) {
				isIE = ua.toString().includes("MSIE") || ua.toString().includes("Trident");
			}

			if (!isIE) {
				markerOptions.icon = markerImg;
			}

			let marker = new google.maps.Marker(markerOptions);

			if (location.innerHTML.trim() !== "") {
				let infoWindow = new google.maps.InfoWindow({
					content: location.innerHTML
				});

				marker.addListener("click", function () {
					infoWindow.open(googleMap, marker);
				});
			}

			return marker;
		});

		let infoBox = map.querySelector("[data-map-infobox]");
		let padding = {left:0,right:0,bottom:32,top:32};

		if (map.nextElementSibling != null) {
				map.classList.add("mb-4")
		}

		if (
			infoBox //  is present
			&& map.closest(".section__sidebar") == null  // not in a sidebar
			&& window.matchMedia("(min-width:48rem)").matches // is >md
			) {
			padding.left = infoBox.offsetLeft + infoBox.offsetWidth + 32;
		}
		
		googleMap.fitBounds(bounds, padding);

			if (markers.length < 2) {
					setTimeout(function () {
							googleMap.setZoom(15)
								if (
										infoBox //  is present
										&& map.closest(".section__sidebar") == null  // not in a sidebar
										&& window.matchMedia("(min-width:48rem)").matches // is >md
								) {
										if (window.matchMedia("(min-width:62rem)").matches) {
										  googleMap.panBy(infoBox.offsetLeft - infoBox.offsetWidth + 200, 0)
										}
                    else {
										  googleMap.panBy(infoBox.offsetLeft - infoBox.offsetWidth + 100, 0)
                    }
								}
					}, 500);
			}
			else {
				this.enableClusters(googleMap, markers, markerStyles);
			}
	},
	enableClusters: function (googleMap, markers, markerStyles) {

		let clusterImg = "data:image/svg+xml;base64," + window.btoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="' + markerStyles.backgroundColor + '" viewBox="0 0 28 28"><circle cx="14" cy="14" r="14"/></svg>');

		let clusterStyles = [1, 2, 3, 4, 5].map(i => {

			let width = 40 + (i * 10);
			let textSize = parseInt(width / 4);

			return {
				width,
				height: width,
				url: clusterImg,
				textColor: markerStyles.color,
				textSize
			};
		});

		let markerCluster = new MarkerClusterer(googleMap, markers, {
			styles: clusterStyles
		});
	}

};

export default map.init();